import Modal from '@scripts/modules/Modal.js';
import Tac from '@scripts/modules/Tac.js';
import FreecallForm from '@scripts/modules/FreecallForm.js';
import RequestForm from '@scripts/modules/RequestForm.js';
import FeedbackForm from '@scripts/modules/FeedbackForm.js';
import PhoneInputMask from '@scripts/modules/PhoneInputMask.js';
import TextSlider from '@scripts/modules/TextSlider.js';
import ImageViewerAutoloader from '@scripts/modules/ImageViewerAutoloader.js';
import CatalogFilter from '@scripts/modules/CatalogFilter.js';
import Dropdown from '@scripts/modules/Dropdown.js';
import GalleryFilter from '@scripts/modules/GalleryFilter.js';
import FilterToggler from '@scripts/modules/FilterToggler.js';
import ShowMore from '@scripts/modules/ShowMore.js';  
import SideMenu from '@scripts/modules/SideMenu.js';  
import PageUp from '@scripts/modules/PageUp.js';  
import PageUpBar from '@scripts/modules/PageUpBar.js';  
import FixedMenu from '@scripts/modules/FixedMenu.js';
import LiveSearch from '@scripts/modules/LiveSearch.js';
// import messageModal from '@scripts/modules/MessageModal.js';



window.addEventListener('DOMContentLoaded', () => {
  'use strict';
  
  // console.log('app.js');
  // window.Hammer = Hammer

  // установка маскирования для полей ввода телефонных номеров
  const phoneSelector = 'input.mask';
  new PhoneInputMask(phoneSelector);

  // настройка и привязка всех модальных окон приложения к вызывающим элементам
  const modal = new Modal(),
    excludedModals = ['freecall-form', 'feedback-form', 'request-form'];
  modal.prepareAll(excludedModals);

  // инициализируем форму обратного звонка
  new FreecallForm();

  // инициализируем форму заявки на товар  
  if (RequestForm.existsOnPage()) {
    new RequestForm();
  }

  // инициализируем форму обратной связи
  if (FeedbackForm.existsOnPage()) {
    new FeedbackForm();
  }

  if (!/android|iphone|ipod|series60|symbian|windows ce|blackberry/i.test(navigator.userAgent)) {  
    new ImageViewerAutoloader();  
  }

  // вкладки, переходящие в аакордеон при низких разрешениях экрана
  new Tac();

  // инициализируем текстовые слайдеры
  const sliders = document.querySelectorAll('.text-slider');    
  sliders.forEach((slider) => {
    new TextSlider(slider);
  })

  if (CatalogFilter.existsOnPage()) {
      new FilterToggler();
      new CatalogFilter();
      new Dropdown();
    }

  if (GalleryFilter.existsOnPage()) {
    new FilterToggler();
    new GalleryFilter();
  }
  // сокрытие части строк в таблице с ценами в карточке товара
  new ShowMore({
    selector: '.product-prices table.prices tr',
    limit: 11,
    trigger: ".product-prices .show-more"
  });

  // сокрытие части строк в таблице с характеристиками в карточке товара
  new ShowMore({
    selector: '.product-details__group--specs li',
    limit: 5,
    trigger: ".product-details__group--specs .show-more"
  });

  new PageUp(".page-up");

  

  // const searchBtn = document.querySelector(".header__search");
  // привязка формы поиска к вызывающим элементам
  const liveSearch = new LiveSearch();
  const liveSearchTriggers = document.querySelectorAll('[data-target="live-search"]');
  liveSearchTriggers.forEach((trigger) => {
    trigger.addEventListener('click', function(){
      liveSearch.show();
    })
  })

  
});


window.addEventListener('load', () => {
  'use strict';

  // инициализация фиксированного меню
  const headerHeight = document.querySelector('header').offsetHeight;
  new FixedMenu({
    selector: '.fixed-menu',
    threshold: headerHeight
  });

  new SideMenu({
    container: "[data-side-menu]",
    fixedMenu: ".fixed-menu",
    rightOffset: 40,
    fromWidth: 768
  });

  new PageUpBar({
    contentContainer: "footer .inner",
    bar: ".page-up-bar",
    // barMinWidth: 120
    barMinWidth: 136
  });

  // if (!localStorage.getItem('important-message-seen'))
  //   messageModal.showMessage(
  //     'Уважаемые клиенты, в связи с нестабильной ситуацией, сложившейся на рынке, просим уточнять актуальные цены у менеджеров компании по телефонам, указанным на сайте.',
  //     messageModal.MESSAGE_IMPORTANCE_HIGH);
  //   localStorage.setItem('important-message-seen', 'true')

});